import { getItemsConfig } from 'components/common/func';
import { useEffect, useState } from 'react';

export const getEwalletNumberConfig = (ewalletConfig) => ({
  name: ewalletConfig?.ewalletNumberName,
  visible: ewalletConfig?.ewalletNumberVisible,
  required: ewalletConfig?.ewalletNumberRequired,
  format: ewalletConfig?.ewalletNumberFormat,
  regex: ewalletConfig?.ewalletNumberRegex,
  example: ewalletConfig?.ewalletNumberExample,
  min: ewalletConfig?.ewalletNumberMin,
  max: ewalletConfig?.ewalletNumberMax,
  tooltip: ewalletConfig?.ewalletNumberHint,
});
export const getEwalletExpireConfig = (ewalletConfig) => ({
  visible: ewalletConfig?.expiryDateVisible,
  required: ewalletConfig?.expiryDateRequired,
});

const useGetConfig = ({
  countryConfig,
  dmCode = null,
  spCode = null,
  currencyCode = null,
  item = null,
  deps = [],
}) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (countryConfig) {
      let phoneConfig;
      let additionalInfoConfig;
      let addressConfig;
      let bankConfig;
      let ewalletConfig;

      phoneConfig = getItemsConfig(
        countryConfig?.phones,
        countryConfig?.countryCode,
        dmCode,
        spCode,
        currencyCode
      );

      additionalInfoConfig = getItemsConfig(
        countryConfig?.additionalInfos,
        countryConfig?.countryCode,
        dmCode,
        spCode,
        currencyCode
      );

      addressConfig = getItemsConfig(
        countryConfig?.addresses,
        countryConfig?.countryCode
      );

      bankConfig = getItemsConfig(
        countryConfig?.banks,
        countryConfig?.countryCode
      );

      ewalletConfig = getItemsConfig(
        countryConfig?.ewallets,
        countryConfig?.countryCode,
        null,
        null,
        null,
        item
      );

      setConfig({
        // mobiles/phones config
        mobile: {
          name: phoneConfig?.mobileAltName,
          visible: phoneConfig?.mobileVisible,
          required: phoneConfig?.mobileRequired,
          prefix: phoneConfig?.mobilePrefix,
          format: phoneConfig?.mobileFormat,
          regex: phoneConfig?.mobileRegex,
          example: phoneConfig?.mobileExample,
          max: phoneConfig?.mobileMax,
          min: phoneConfig?.mobileMin,
          eitherRequired: phoneConfig?.eitherRequired,
          apiEnabled: phoneConfig?.mobileApiEnabled,
        },
        phone: {
          name: phoneConfig?.homeAltName,
          visible: phoneConfig?.homeVisible,
          required: phoneConfig?.homeRequired,
          prefix: phoneConfig?.homePrefix,
          format: phoneConfig?.homeFormat,
          regex: phoneConfig?.homeRegex,
          example: phoneConfig?.homeExample,
          max: phoneConfig?.homeMax,
          min: phoneConfig?.homeMin,
          eitherRequired: phoneConfig?.eitherRequired,
          apiEnabled: phoneConfig?.homeApiEnabled,
        },

        // additionalInfos config
        fundSource: {
          visible: additionalInfoConfig?.fundSourceVisible,
          required: additionalInfoConfig?.fundSourceRequired,
        },
        purpose: {
          visible: additionalInfoConfig?.purposeVisible,
          required: additionalInfoConfig?.purposeRequired,
        },
        occupation: {
          visible: additionalInfoConfig?.occupationVisible,
          required: additionalInfoConfig?.occupationRequired,
        },
        relationship: {
          visible: additionalInfoConfig?.relationshipVisible,
          required: additionalInfoConfig?.relationshipRequired,
        },
        message: {
          visible: additionalInfoConfig?.messageVisible,
          required: additionalInfoConfig?.messageRequired,
          min: additionalInfoConfig?.messageMin,
          max: additionalInfoConfig?.messageMax,
        },
        addressStreet: {
          name: addressConfig?.streetAltName,
          visible: addressConfig?.streetVisible,
          required: addressConfig?.streetRequired,
          format: addressConfig?.streetFormat,
          regex: addressConfig?.streetRegex,
          example: addressConfig?.streetExample,
          min: addressConfig?.streetMin,
          max: addressConfig?.streetMax,
        },
        addressState: {
          name: addressConfig?.stateAltName,
          visible: addressConfig?.stateVisible,
          required: addressConfig?.stateRequired,
          format: addressConfig?.stateFormat,
          regex: addressConfig?.stateRegex,
          example: addressConfig?.stateExample,
          min: addressConfig?.stateMin,
          max: addressConfig?.stateMax,
        },
        addressSuburb: {
          name: addressConfig?.suburbAltName,
          visible: addressConfig?.suburbVisible,
          required: addressConfig?.suburbRequired,
          format: addressConfig?.suburbFormat,
          regex: addressConfig?.suburbRegex,
          example: addressConfig?.suburbExample,
          min: addressConfig?.suburbMin,
          max: addressConfig?.suburbMax,
        },
        addressPostcode: {
          name: addressConfig?.postcodeAltName,
          visible: addressConfig?.postcodeVisible,
          required: addressConfig?.postcodeRequired,
          format: addressConfig?.postcodeFormat,
          regex: addressConfig?.postcodeRegex,
          example: addressConfig?.postcodeExample,
          min: addressConfig?.postcodeMin,
          max: addressConfig?.postcodeMax,
        },
        addressManualDisable: addressConfig?.manualDisable,

        // banks config
        accountHolder: {
          name: bankConfig?.holderName,
          visible: bankConfig?.holderVisible,
          required: bankConfig?.holderRequired,
          editEnabled: bankConfig?.holderEnabled,
          format: bankConfig?.holderFormat,
          regex: bankConfig?.holderRegex,
          example: bankConfig?.holderExample,
          min: bankConfig?.holderMin,
          max: bankConfig?.holderMax,
        },
        accountNumber: {
          name: bankConfig?.accNumberName,
          type: bankConfig?.accNumberType,
          visible: bankConfig?.accNumberVisible,
          required: bankConfig?.accNumberRequired,
          format: bankConfig?.accNumberFormat,
          regex: bankConfig?.accNumberRegex,
          example: bankConfig?.accNumberExample,
          min: bankConfig?.accNumberMin,
          max: bankConfig?.accNumberMax,
          apiEnabled: bankConfig?.accNumberApiEnabled,
        },
        accountSwift: {
          name: bankConfig?.swiftName,
          type: bankConfig?.swiftType || '',
          visible: bankConfig?.swiftVisible,
          required: bankConfig?.swiftRequired,
          format: bankConfig?.swiftFormat,
          regex: bankConfig?.swiftRegex,
          example: bankConfig?.swiftExample,
          min: bankConfig?.swiftMin,
          max: bankConfig?.swiftMax,
          apiEnabled: bankConfig?.swiftApiEnabled,
        },
        accountBsb: {
          name: bankConfig?.bsbName,
          type: bankConfig?.bsbType || '',
          visible: bankConfig?.bsbVisible,
          required: bankConfig?.bsbRequired,
          format: bankConfig?.bsbFormat,
          regex: bankConfig?.bsbRegex,
          example: bankConfig?.bsbExample,
          min: bankConfig?.bsbMin,
          max: bankConfig?.bsbMax,
          apiEnabled: bankConfig?.bsbApiEnabled,
        },

        // ewallets config
        ewalletNumber: getEwalletNumberConfig(ewalletConfig),
        ewalletExpire: getEwalletExpireConfig(ewalletConfig),
      });
    }
  }, [countryConfig, dmCode, spCode, currencyCode, ...deps]);

  return config || {};
};

export default useGetConfig;
